import { ConnectorConfig } from '../../../models';
import { IsOptional } from 'class-validator'

export class ConnectorConfigStrapi extends ConnectorConfig {
	@IsOptional()
	target: string;
}
